import React, { useContext, useEffect, useState } from 'react';
import styles from './PermissionActions.module.css';
import ModalContext from 'config/context/modalContext';
import CreatePermissionModal from 'features/permissions/components/modals/CreatePermissionModal';
import ChangeKeypairModal from 'features/permissions/components/modals/ChangeKeypairModal';
import DeletePermissionModal from 'features/permissions/components/modals/DeletePermissionModal';
import SetPermissionModal from 'features/permissions/components/modals/SetPermissionModal';

const PermissionActions = ({ name, parent }) => {
    const initialModalState = {
        create: false,
        change: false,
        set: false,
        delete: false
    }

    const { handleModal, modal } = useContext(ModalContext);
    const [modalControl, setModalControl] = useState({ ...initialModalState });

    const showModal = (modalName) => {
        setModalControl(prev => ({ ...prev, [modalName]: true }));
        handleModal(true);
    };

    useEffect(() => {
        if (!modal) {
            setModalControl({ ...initialModalState });
        }
    }, [modal]);

    return (
        <div className={styles.actions_group}>
            <button className={styles.create} onClick={() => showModal("create")}>Create permission</button>
            <button className={styles.change} onClick={() => showModal("change")}>Change keypair</button>
            <button className={styles.set} onClick={() => showModal("set")}>Set permission</button>
            {name != "active" && <button className={styles.delete} onClick={() => showModal("delete")}>Delete permission</button>}

            {modalControl.create && <CreatePermissionModal permissionParentName={name} />}
            {modalControl.change && <ChangeKeypairModal permissionName={name} permissionParentName={parent} />}
            {modalControl.delete && <DeletePermissionModal permissionName={name} permissionParentName={parent} />}
            {modalControl.set && <SetPermissionModal permissionName={name} permissionParentName={parent} />}
        </div>
    );
}

export default PermissionActions;